import React from 'react';
import joi from 'joi-browser';
import { connect } from 'react-redux';
import { Col, Form, Row } from 'antd';
import {
  getById,
  resetState,
  resetSuccessSave,
  save,
} from '../../modules/categories';
import Layout from '../Layout';
import EditForm from '../../components/EditForm';

class CategoryForm extends EditForm {
  validationSchema = joi.object({
    id: joi.number().default(null),
    name: joi.string().trim().required(),
    logo: joi.alternatives().try(joi.object(), joi.string()).when('id',
      { is: null, then: joi.required() }),
  });

  styles = {
    ...this.styles,
    layoutInput: {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    },
    btnSubmit: {
      marginRight: 10,
    },
    uploadForm: {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    },
  };

  render() {
    const { successSave, error } = this.props;

    return (
      <Layout>
        <Form onSubmit={this.onSubmit}>
          {this.renderFormActions('Save')}
          <Row className="container-sm">
            <Col span={24}>
              {successSave && this.renderSuccessAlert(
                'Category has been successfully saved.')}
              {error && this.renderErrorAlert(error)}
              {this.renderInput('name', true, 'Name', null, null, 1, this.styles.layoutInput)}
              {this.renderUpload('logo',
                '.jpg, .png, .jpeg',
                true,
                'Upload Image',
                false,
                this.styles.uploadForm)}
            </Col>
          </Row>
        </Form>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.categories,
  }),
  {
    getById,
    onSubmit: save,
    resetState,
    resetSuccessSave,
  },
)(CategoryForm);



// WEBPACK FOOTER //
// ./src/containers/Categories/CategoryForm.js